import { Button } from '@/components/ui/button'
import { useChatContext } from '@/context/ChatProvider'
import { useChatStore } from '@/store/chat.store'
import { ChevronDown } from 'lucide-react'

const FloatScrollToBottomButton = () => {
  const showScrollToBottom = useChatStore(state => state.showScrollToBottom)

  const { scrollToBottom } = useChatContext()

  if (!showScrollToBottom) return null

  return (
    <div className='absolute right-2 bottom-2 z-50'>
      <Button
        onClick={() => scrollToBottom()}
        size='icon'
        className='size-6 rounded-full opacity-70 shadow-lg hover:opacity-100'
        title='Alta git'
      >
        <ChevronDown className='size-3' />
      </Button>
    </div>
  )
}

export default FloatScrollToBottomButton
